export const mockComplianceData = [
  {
    areaName: 'Atlanta, GA',
    totalEmployees: 3256,
    totalSites: 4,
    compliantSites: 4,
    worksites: [
      {
        name: 'ATL - Airport Operations, 6000 N Terminal Pkwy',
        employeeCount: 1320,
        isCompliant: true,
      },
      {
        name: 'ATL - HQ, 1030 Delta Blvd',
        employeeCount: 952,
        isCompliant: true,
      },
      {
        name: 'ATL - TOP, 1775 M H Jackson Service Rd',
        employeeCount: 592,
        isCompliant: true,
      },
      {
        name: 'ATL - RES, 1020 Delta Blvd',
        employeeCount: 392,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Georgia employers offering subsidised parking should document a cash-out alternative',
      },
      { text: 'Annual commuter options disclosure to all worksite employees' },
      {
        text: 'Clean Air Campaign registration recommended for sites >250 employees',
      },
    ],
  },
  {
    areaName: 'New York, NY',
    totalEmployees: 848,
    totalSites: 2,
    compliantSites: 1,
    worksites: [
      {
        name: 'JFK - Airport Operations, Building 144',
        employeeCount: 520,
        isCompliant: true,
      },
      {
        name: 'LGA - Airport Operations, Grand Central Pkwy',
        employeeCount: 328,
        isCompliant: false,
      },
    ],
    complianceRequirements: [
      {
        text: 'NYC employers with 20+ full-time employees must offer a pre-tax transit benefit',
      },
      { text: 'Benefit must cover the full IRS monthly transit exclusion' },
      { text: 'Records of the offer must be retained for two years' },
      { text: 'Annual filing required' },
    ],
  },
  {
    areaName: 'Minneapolis–St Paul, MN',
    totalEmployees: 1312,
    totalSites: 3,
    compliantSites: 3,
    worksites: [
      {
        name: 'MSP - Airport Operations, 4300 Glumack Dr',
        employeeCount: 568,
        isCompliant: true,
      },
      {
        name: 'MSP - TOP, 7150 Humphrey Dr',
        employeeCount: 392,
        isCompliant: true,
      },
      {
        name: 'MSP - RES, 7500 Airline Dr',
        employeeCount: 352,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Pre-tax transit deductions must be offered where transit service is available',
      },
      { text: 'Metropolitan Council TDM reporting for sites >100 employees' },
    ],
  },
  {
    areaName: 'Salt Lake City, UT',
    totalEmployees: 792,
    totalSites: 2,
    compliantSites: 2,
    worksites: [
      {
        name: 'SLC - Airport Operations, 776 N Terminal Dr',
        employeeCount: 480,
        isCompliant: true,
      },
      {
        name: 'SLC - RES, 260 N 2370 W',
        employeeCount: 312,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Disclose available commuter options to employees at each worksite',
      },
      { text: 'UTA employer pass program participation recommended' },
    ],
  },
  {
    areaName: 'Detroit, MI',
    totalEmployees: 536,
    totalSites: 1,
    compliantSites: 0,
    worksites: [
      {
        name: 'DTW - Airport Operations, 1 Renaissance Center',
        employeeCount: 536,
        isCompliant: false,
      },
    ],
    complianceRequirements: [
      {
        text: 'Annual disclosure of available commuter benefits to all worksite employees',
      },
      { text: 'Commuter benefits program not yet configured for this site' },
    ],
  },
  {
    areaName: 'Los Angeles, CA',
    totalEmployees: 520,
    totalSites: 1,
    compliantSites: 1,
    worksites: [
      {
        name: 'LAX - Airport Operations, 6040 Avion Dr',
        employeeCount: 520,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'California SB 1339 requires a commuter benefit program for employers with 50+ employees',
      },
      { text: 'Registration with the regional air quality district required' },
      { text: 'Annual compliance reporting' },
    ],
  },
  {
    areaName: 'Seattle, WA',
    totalEmployees: 408,
    totalSites: 1,
    compliantSites: 1,
    worksites: [
      {
        name: 'SEA - Airport Operations, 17801 International Blvd',
        employeeCount: 408,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Seattle employers with 20+ employees must offer pre-tax transit benefits',
      },
      { text: 'ORCA business account recommended for enrolled employees' },
    ],
  },
  {
    areaName: 'Boston, MA',
    totalEmployees: 328,
    totalSites: 1,
    compliantSites: 1,
    worksites: [
      {
        name: 'BOS - Airport Operations, 1 Harborside Dr',
        employeeCount: 328,
        isCompliant: true,
      },
    ],
    complianceRequirements: [
      {
        text: 'Massachusetts employers should offer pre-tax transit under IRC 132(f)',
      },
      { text: 'MassDOT commuter survey participation for sites >50 employees' },
    ],
  },
]
